export default __webpack_public_path__ + "static/media/stbernadette.ff1298ec.jpg";